import { render, staticRenderFns } from "./ChatBirthdayV2.vue?vue&type=template&id=0a7453bd&scoped=true"
import script from "./ChatBirthdayV2.vue?vue&type=script&lang=js"
export * from "./ChatBirthdayV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7453bd",
  null
  
)

export default component.exports